import React, { Dispatch, SetStateAction } from "react";

import { Box } from "@mui/material";

import { ChannelsList } from "../ChannelsList";
import { TeamsDocGrid } from "../TeamsDocGrid";
import { UserMenu } from "../UserMenu";

interface ITeamsIntegrationModalFileListStepProps {
  setSelectedChannel: Dispatch<
    SetStateAction<
      { drive_id: string; item_id: string; channelName: string; teamName: string } | undefined
    >
  >;
  selectedChannel:
    | { drive_id: string; item_id: string; channelName: string; teamName: string }
    | undefined;
  callbackClose: (_update: boolean) => void;
  onLoadingChange: (_loading: boolean) => void;
}

export const TeamsIntegrationModalFileListStep: React.FC<
  ITeamsIntegrationModalFileListStepProps
> = ({ callbackClose, setSelectedChannel, selectedChannel, onLoadingChange }) => {
  return (
    <Box display="flex" flexDirection="row" width="100%" height="70vh">
      <Box display="flex" flexDirection="column" width="300px" height="100%">
        <UserMenu callbackClose={callbackClose} />
        <ChannelsList onSelectChannel={setSelectedChannel} />
      </Box>
      <Box flex={1} height="100%">
        <TeamsDocGrid selectedChannel={selectedChannel} onLoadingChange={onLoadingChange} />
      </Box>
    </Box>
  );
};
